// extracted by mini-css-extract-plugin
export default {"nav":"k7lAld","icon":"cLY2ge","withCount":"bIV1XJ","badge":"RYis25"};